module.exports = __webpack_public_path__ + "fonts/RobotoMono-Medium.f2cc4e9c.woff";